<template>
	<b-card-body>
		<div class="row">
			<planned-level-features-feat v-for="(feat, index) in feats" :key="'level-'+level+'-feat-'+index" :level="level" :index="index" :feat="feat" @discard="removeFeat" />

			<planned-level-features-theme :level="level" :theme="theme" v-if="level % 6 == 0 || level == 1" />

			<planned-level-features-ability v-for="(ability, index) in abilities" :key="'level-'+level+'-ability-'+index" :level="level" :index="index" :ability="ability" @discard="removeAbility" />
		</div>

		<div class="row justify-content-center my-2">
			<button class="btn btn-sm btn-secondary mx-1" @click="addFeat()">Add Feat</button>&nbsp;
			<button class="btn btn-sm btn-secondary mx-1" @click="addAbility()">Add Class Ability</button>
		</div>
	</b-card-body>
</template>

<script>
import PlannedLevelFeaturesFeat from '@/components/planning/PlannedLevelFeaturesFeat.vue'
import PlannedLevelFeaturesTheme from '@/components/planning/PlannedLevelFeaturesTheme.vue'
import PlannedLevelFeaturesAbility from '@/components/planning/PlannedLevelFeaturesAbility.vue'

export default {
	props: [
		'level',
	],
	components: {
		PlannedLevelFeaturesFeat,
		PlannedLevelFeaturesTheme,
		PlannedLevelFeaturesAbility,
	},
	computed: {
		feats: function(){
			return this.$store.state.Character.Levels[this.level].Feats
		},
		abilities: function(){
			return this.$store.state.Character.Levels[this.level].Abilities
		},
		theme: function(){
			return this.$store.state.Character.Levels[this.level].Theme
		}
	},
	watch: {
		feats: function(value){
			this.update('Feats', value)
		},
		abilities: function(value){
			this.update('Abilities', value)
		},
	},
	methods: {
		update: function(property, value){
			this.$store.commit('setCharacterProp',[
				{
					key: `Levels[${this.level}].${property}`,
					val: value,
				}
			])
		},
		addFeat() {
			this.feats.push({Name:"",Description:""})
		},
		addAbility() {
			this.abilities.push({Name:"",Description:""})
		},
		removeFeat(index) {
			this.feats.splice(index, 1)
		},
		removeAbility(index) {
			this.abilities.splice(index, 1)
		}
	}
}
</script>

<style scoped>

</style>